export default "__VITE_ASSET__CLPNSn31__"